import React from 'react';
import { FadeIn } from './FadeIn';
import { PullQuote } from './PullQuote';
export function TransformSection() {
  return <section className="py-4 md:py-10 px-4 md:px-6" data-id="element-377">
      <div className="max-w-[640px] mx-auto space-y-1.5 md:space-y-3 text-sm md:text-base text-charcoal/90 font-light" data-id="element-378">
        <FadeIn data-id="element-379">
          <h2 className="font-serif text-xl md:text-2xl text-navy mb-2 md:mb-6 text-center" data-id="element-380">
            What Happens When The Program Breaks
          </h2>
        </FadeIn>

        <FadeIn data-id="element-381">
          <p data-id="element-382">Imagine opening your banking app…</p>
          <p className="mt-1" data-id="element-383">and feeling calm.</p>
        </FadeIn>

        <FadeIn data-id="element-384">
          <div className="mt-1.5 space-y-0.5" data-id="element-385">
            <p data-id="element-386">Not nervous.</p>
            <p data-id="element-387">Not guilty.</p>
            <p className="font-medium text-navy" data-id="element-388">Just calm.</p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-389">
          <p className="mt-2 md:mt-4" data-id="element-390">
            Imagine buying things intentionally instead of impulsively.
          </p>
          <p className="mt-1" data-id="element-391">Watching your savings slowly grow.</p>
        </FadeIn>

        <FadeIn data-id="element-392">
          <p className="mt-2 md:mt-4" data-id="element-393">
            But the biggest change wouldn't just be the money.
          </p>
          <p className="mt-1" data-id="element-394">It would be something deeper.</p>
        </FadeIn>

        <PullQuote text="Self-trust." data-id="element-395" />

        <FadeIn data-id="element-396">
          <p className="text-center font-serif text-base md:text-lg text-navy" data-id="element-397">
            Trusting yourself to make smart financial decisions again.
          </p>
        </FadeIn>
      </div>
    </section>;
}